module.exports = __webpack_public_path__ + "images/role-athlete.7de6efc450dc99437a2cede1108f3735.png";